import L from "leaflet";

export const getTileBounds = (
  x: number,
  y: number,
  z: number
): [[number, number], [number, number]] => {
  const n = Math.pow(2, z);
  const west = (x / n) * 360 - 180;
  const east = ((x + 1) / n) * 360 - 180;
  const north =
    (180 / Math.PI) * Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n)));
  const south =
    (180 / Math.PI) * Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / n)));

  return [
    [south, west],
    [north, east],
  ];
};
